/**
 * Custom Cart Drawer
 *
 * Un cart drawer independiente que funciona con AJAX y es compatible con Seal Subscriptions.
 * Intercepta todos los add to cart y muestra el drawer sin redirect a /cart.
 */
(function() {
  'use strict';
 
  // Configuracion
  var config = {
    selectors: {
      drawer: '#CustomCartDrawer',
      overlay: '#CustomCartOverlay',
      container: '#CustomCartContainer',
      closeBtn: '.js-custom-drawer-close',
      cartIcon: '.js-drawer-open-cart, .cart-link, [href="/cart"]'
    },
    classes: {
      drawerOpen: 'is-open',
      overlayVisible: 'is-visible',
      loading: 'is-loading',
      bodyOpen: 'custom-drawer-open'
    },
    moneyFormat: window.theme && window.theme.settings ? window.theme.settings.moneyFormat : '${{amount}}',
    routes: {
      cart: '/cart.js',
      cartAdd: '/cart/add.js',
      cartChange: '/cart/change.js',
      cartUpdate: '/cart/update.js'
    }
  };
 
  // Estado
  var state = {
    isOpen: false,
    isLoading: false,
    cart: null
  };
 
  // Elementos del DOM
  var elements = {};

  // =============================================
  // WSG Wholesale Price Cache
  // =============================================
  var WSG_PRICE_CACHE_KEY = 'wsg_price_cache';

  function getWsgPriceCache() {
    try {
      var cached = sessionStorage.getItem(WSG_PRICE_CACHE_KEY);
      return cached ? JSON.parse(cached) : {};
    } catch(e) {
      return {};
    }
  }

  function setWsgPriceCache(cache) {
    try {
      sessionStorage.setItem(WSG_PRICE_CACHE_KEY, JSON.stringify(cache));
    } catch(e) {}
  }

  function parseMoney(priceStr) {
    if (!priceStr) return 0;
    var cleaned = priceStr.replace(/[^0-9.,]/g, '');
    if (cleaned.indexOf(',') !== -1 && cleaned.indexOf('.') !== -1) {
      cleaned = cleaned.replace(/,/g, '');
    } else if (cleaned.indexOf(',') !== -1) {
      var commaPos = cleaned.lastIndexOf(',');
      if (cleaned.length - commaPos === 3) {
        cleaned = cleaned.replace(',', '.');
      } else {
        cleaned = cleaned.replace(/,/g, '');
      }
    }
    var value = parseFloat(cleaned);
    if (isNaN(value)) return 0;
    return Math.round(value * 100);
  }

  function captureWholesalePrice(form) {
    if (typeof window.isWsgCustomer === 'undefined' || !window.isWsgCustomer) return;

    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return;
    var variantId = variantInput.value;

    var priceText = null;

    // Strategy 1: .wsgPrice elements on PDP (WSG replaces .product__price with .wsgPrice)
    var wsgPriceEls = document.querySelectorAll('.wsgPrice');
    for (var i = 0; i < wsgPriceEls.length; i++) {
      var txt = wsgPriceEls[i].textContent.trim();
      if (txt && /\d/.test(txt)) {
        priceText = txt;
        break;
      }
    }

    // Strategy 2: Look near the form product section
    if (!priceText) {
      var productSection = form.closest('.product-section') || form.closest('.product-single__meta');
      if (productSection) {
        var wsgEl = productSection.querySelector('.wsgPrice');
        if (wsgEl && wsgEl.textContent.trim()) priceText = wsgEl.textContent.trim();
      }
    }

    // Strategy 3: WSG-modified price displays (class contains wsg)
    if (!priceText) {
      var allWsg = document.querySelectorAll('[class*="wsg"]');
      for (var j = 0; j < allWsg.length; j++) {
        var t = allWsg[j].textContent.trim();
        if (/^\$[\d,.]+$/.test(t)) {
          priceText = t;
          break;
        }
      }
    }

    // Strategy 4: data-wsg-price on active pack button (custom-treat-grid)
    if (!priceText) {
      var card = form.closest('.treat-card') || form.closest('.product-card');
      if (card) {
        var activeBtn = card.querySelector('.pack-btn.active[data-wsg-price]');
        if (activeBtn) priceText = activeBtn.getAttribute('data-wsg-price');
      }
    }

    if (priceText) {
      var cents = parseMoney(priceText);
      if (cents > 0) {
        var cache = getWsgPriceCache();
        cache[String(variantId)] = cents;
        setWsgPriceCache(cache);
        console.log('[Custom Cart Drawer] Captured WSG price for variant ' + variantId + ': ' + priceText + ' (' + cents + ' cents)');
      }
    } else {
      console.warn('[Custom Cart Drawer] WSG customer but could not capture wholesale price for variant ' + variantId + '. .wsgPrice elements found: ' + document.querySelectorAll('.wsgPrice').length);
    }
  }
 
  /**
   * Inicializacion
   */
  function init() {
    // Obtener elementos del DOM
    elements.drawer = document.querySelector(config.selectors.drawer);
    elements.overlay = document.querySelector(config.selectors.overlay);
    elements.container = document.querySelector(config.selectors.container);
 
    if (!elements.drawer || !elements.container) {
      console.error('[Custom Cart Drawer] Elementos del drawer no encontrados');
      return;
    }
 
    console.log('[Custom Cart Drawer] Inicializando...');
 
    // Registrar event listeners
    bindEvents();
 
    // Cargar el carrito inicial
    fetchCart();
 
    console.log('[Custom Cart Drawer] Inicializado correctamente');
  }
 
  /**
   * Registrar event listeners
   */
  function bindEvents() {
    // Interceptar todos los submits de formularios de add to cart
    document.addEventListener('submit', handleFormSubmit, true);
 
    // Cerrar drawer
    document.querySelectorAll(config.selectors.closeBtn).forEach(function(btn) {
      btn.addEventListener('click', closeDrawer);
    });
 
    // Cerrar con overlay
    if (elements.overlay) {
      elements.overlay.addEventListener('click', closeDrawer);
    }
 
    // Cerrar con ESC
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && state.isOpen) {
        closeDrawer();
      }
    });
 
    // Abrir drawer al hacer click en icono del carrito
    document.querySelectorAll(config.selectors.cartIcon).forEach(function(icon) {
      icon.addEventListener('click', function(e) {
        // Solo si es un link al carrito, no si es el checkout
        var href = this.getAttribute('href');
        if (href === '/cart' || this.classList.contains('js-drawer-open-cart') || this.classList.contains('cart-link')) {
          e.preventDefault();
          openDrawer();
        }
      });
    });
 
    // Event delegation para botones de cantidad y eliminar
    elements.container.addEventListener('click', handleContainerClick);

    // Event delegation for manual quantity input changes
    elements.container.addEventListener('change', handleQtyInputChange);
    elements.container.addEventListener('keydown', function(e) {
      if (e.target.classList.contains('js-qty-input') && e.key === 'Enter') {
        e.preventDefault();
        e.target.blur();
      }
    });
  }
 
  /**
   * Manejar clicks dentro del contenedor del carrito
   */
  function handleContainerClick(e) {
    var target = e.target;
 
    // Boton de incrementar cantidad
    if (target.classList.contains('js-qty-plus') || target.closest('.js-qty-plus')) {
      var btn = target.classList.contains('js-qty-plus') ? target : target.closest('.js-qty-plus');
      var key = btn.dataset.key;
      var qtyInput = btn.parentElement.querySelector(".js-qty-input");
      var currentQty = qtyInput ? parseInt(qtyInput.value, 10) : parseInt(btn.dataset.qty, 10);
      updateItemQuantity(key, currentQty + 1);
      return;
    }
 
    // Boton de decrementar cantidad
    if (target.classList.contains('js-qty-minus') || target.closest('.js-qty-minus')) {
      var btn = target.classList.contains('js-qty-minus') ? target : target.closest('.js-qty-minus');
      var key = btn.dataset.key;
      var qtyInput = btn.parentElement.querySelector(".js-qty-input");
      var currentQty = qtyInput ? parseInt(qtyInput.value, 10) : parseInt(btn.dataset.qty, 10);
      if (currentQty > 1) {
        updateItemQuantity(key, currentQty - 1);
      } else {
        removeItem(key);
      }
      return;
    }
 
    // Boton de eliminar
    if (target.classList.contains('js-remove-item') || target.closest('.js-remove-item')) {
      var btn = target.classList.contains('js-remove-item') ? target : target.closest('.js-remove-item');
      var key = btn.dataset.key;
      removeItem(key);
      return;
    }
  }
 
  /**
   * Manejar cambio manual de cantidad en el input
   */
  function handleQtyInputChange(e) {
    var target = e.target;
    if (!target.classList.contains('js-qty-input')) return;

    var key = target.dataset.key;
    var newQty = parseInt(target.value, 10);

    if (isNaN(newQty) || newQty < 0) {
      target.value = 1;
      newQty = 1;
    }

    if (newQty === 0) {
      removeItem(key);
    } else {
      updateItemQuantity(key, newQty);
    }
  }

  /**
   * Interceptar submit de formularios de add to cart
   */
  function handleFormSubmit(e) {
    var form = e.target;
 
    // NO interceptar formularios dentro del drawer (como el checkout)
    if (form.closest('#CustomCartDrawer')) {
      return;
    }
 
    // Verificar si es un formulario de add to cart
    if (!isAddToCartForm(form)) {
      return;
    }
 
    // Verificar si el boton esta deshabilitado
    var submitBtn = form.querySelector('[type="submit"][name="add"], .add-to-cart, .product-form__submit');
    if (submitBtn && submitBtn.disabled) {
      return;
    }
 
    // Prevenir submit nativo
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
 
    console.log('[Custom Cart Drawer] Formulario interceptado');
 
    // Agregar producto al carrito
    addToCart(form, submitBtn);
  }
 
  /**
   * Verificar si es un formulario de add to cart
   */
  function isAddToCartForm(form) {
    if (!form || form.tagName !== 'FORM') {
      return false;
    }
 
    var action = form.getAttribute('action') || '';
    var formId = form.getAttribute('id') || '';
    var hasVariantInput = form.querySelector('[name="id"]');
    var hasAddButton = form.querySelector('[name="add"], .add-to-cart, .product-form__submit');
 
    // Excluir formularios que no sean de add to cart
    if (action.indexOf('/checkout') !== -1) {
      return false;
    }
 
    return action.indexOf('/cart/add') !== -1 ||
           form.classList.contains('product-single__form') ||
           form.classList.contains('product-form') ||
           formId.indexOf('AddToCartForm') !== -1 ||
           formId.indexOf('product-form') !== -1 ||
           (hasVariantInput && hasAddButton);
  }
 
  /**
   * Agregar producto al carrito
   */
  function addToCart(form, submitBtn) {
    if (state.isLoading) return;
 
    setLoading(true);
 
    // Mostrar loading en el boton
    if (submitBtn) {
      submitBtn.classList.add('btn--loading');
      submitBtn.disabled = true;
    }
 
    // Serializar formulario
    var formData = new FormData(form);
 
    // Log para debugging
    console.log('[Custom Cart Drawer] Datos del formulario:');
    for (var pair of formData.entries()) {
      console.log('  ' + pair[0] + ':', pair[1]);
    }
 
    // Capture wholesale price from DOM before AJAX call
    captureWholesalePrice(form);

    // Hacer POST a /cart/add.js
    fetch(config.routes.cartAdd, {
      method: 'POST',
      body: formData
    })
    .then(function(response) {
      if (!response.ok) {
        return response.json().then(function(data) {
          throw data;
        });
      }
      return response.json();
    })
    .then(function(item) {
      console.log('[Custom Cart Drawer] Producto agregado:', item);
 
      // Restaurar boton
      if (submitBtn) {
        submitBtn.classList.remove('btn--loading');
        submitBtn.disabled = false;
      }
 
      // Actualizar carrito y abrir drawer
      fetchCart().then(function() {
        openDrawer();
      });
 
      // Disparar eventos para compatibilidad
      dispatchCartEvents(item);
    })
    .catch(function(error) {
      console.error('[Custom Cart Drawer] Error:', error);
 
      // Restaurar boton
      if (submitBtn) {
        submitBtn.classList.remove('btn--loading');
        submitBtn.disabled = false;
      }
 
      setLoading(false);
 
      // Mostrar error
      showError(form, error);
    });
  }
 
  /**
   * Obtener carrito desde el servidor
   */
  function fetchCart() {
    return fetch(config.routes.cart)
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        state.cart = cart;
        renderCart(cart);
        updateCartBubble(cart);
        setLoading(false);
        return cart;
      })
      .catch(function(error) {
        console.error('[Custom Cart Drawer] Error al obtener carrito:', error);
        setLoading(false);
      });
  }
 
  /**
   * Renderizar el carrito
   */
  function renderCart(cart) {
    if (!cart || cart.item_count === 0) {
      renderEmptyCart();
      return;
    }
 
    var html = '<div class="ccd-scrollable">';
 
    // Renderizar items
    cart.items.forEach(function(item) {
      html += renderCartItem(item);
    });
 
    html += '</div>';
 
    // Footer
    html += '<div class="ccd-footer">';
 
    // Descuentos del carrito
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
      cart.cart_level_discount_applications.forEach(function(discount) {
        html += '<div class="ccd-footer__discount">';
        html += discount.title + ' (-' + formatMoney(discount.total_allocated_amount) + ')';
        html += '</div>';
      });
    }
 
    // Subtotal
    html += '<div class="ccd-footer__row">';
    html += '<span class="ccd-footer__label">Subtotal</span>';
    html += '<span class="ccd-footer__value">' + formatMoney(cart.total_price) + '</span>';
    html += '</div>';
 
    // Nota de envio
    html += '<p class="ccd-footer__note">Shipping calculated at checkout</p>';
 
    // Boton de checkout - Link directo a /checkout
    var checkoutUrl = (typeof window.isWsgCustomer !== 'undefined' && window.isWsgCustomer) ? '/pages/ws-cart' : '/checkout';
    html += '<a href="' + checkoutUrl + '" class="ccd-footer__checkout">Checkout</a>';
 
    html += '</div>';
 
    elements.container.innerHTML = html;

    // For WSG wholesale customers, fetch and apply wholesale prices
    applyWholesalePricing(cart);
  }
 
  /**
   * Renderizar un item del carrito
   */
  function renderCartItem(item) {
    var imageUrl = item.image ? getSizedImageUrl(item.image, '160x160') : 'https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
 
    var html = '<div class="ccd-item" data-key="' + item.key + '" data-variant-id="' + item.variant_id + '">';
 
    // Imagen
    html += '<div class="ccd-item__image">';
    html += '<a href="' + item.url + '">';
    html += '<img src="' + imageUrl + '" alt="' + escapeHtml(item.product_title) + '">';
    html += '</a>';
    html += '</div>';
 
    // Detalles
    html += '<div class="ccd-item__details">';
    html += '<a href="' + item.url + '" class="ccd-item__title">' + escapeHtml(item.product_title) + '</a>';
 
    // Variante
    if (item.variant_title && item.variant_title !== 'Default Title') {
      html += '<div class="ccd-item__variant">' + escapeHtml(item.variant_title) + '</div>';
    }
 
    // Propiedades (para suscripciones, etc.)
    if (item.properties) {
      var propsHtml = '';
      for (var key in item.properties) {
        if (item.properties.hasOwnProperty(key) && item.properties[key] && key.charAt(0) !== '_') {
          propsHtml += '<div>' + escapeHtml(key) + ': ' + escapeHtml(item.properties[key]) + '</div>';
        }
      }
      if (propsHtml) {
        html += '<div class="ccd-item__properties">' + propsHtml + '</div>';
      }
    }
 
    // Selling Plan (para suscripciones)
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      html += '<div class="ccd-item__properties">';
      html += escapeHtml(item.selling_plan_allocation.selling_plan.name);
      html += '</div>';
    }
 
    // Precio y cantidad
    html += '<div class="ccd-item__price-row">';
 
    // Cantidad
    html += '<div class="ccd-item__quantity">';
    html += '<button type="button" class="ccd-item__qty-btn js-qty-minus" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Decrease quantity">-</button>';
    html += '<input type="number" class="ccd-item__qty-input js-qty-input" data-key="' + item.key + '" value="' + item.quantity + '" min="0" step="1" aria-label="Quantity">';
    html += '<button type="button" class="ccd-item__qty-btn js-qty-plus" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>';
    html += '</div>';
 
    // Precio
    html += '<div class="ccd-item__price">';
 
    // Mostrar precio original si hay descuento
    if (item.original_line_price !== item.final_line_price) {
      html += '<span class="ccd-item__price--original">' + formatMoney(item.original_line_price) + '</span>';
    }
 
    html += formatMoney(item.final_line_price);
    html += '</div>';
 
    html += '</div>';
 
    // Boton eliminar
    html += '<button type="button" class="ccd-item__remove js-remove-item" data-key="' + item.key + '">Remove</button>';
 
    // Descuentos del item
    if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
      item.line_level_discount_allocations.forEach(function(discount) {
        html += '<div class="ccd-footer__discount">';
        html += escapeHtml(discount.discount_application.title) + ' (-' + formatMoney(discount.amount) + ')';
        html += '</div>';
      });
    }
 
    html += '</div>'; // details
    html += '</div>'; // cart-item
 
    return html;
  }
 
  /**
   * Apply Wholesale Gorilla pricing to the cart drawer.
   * WSG modifies prices via DOM on product/collection pages but the cart API
   * always returns retail prices. This fetches WSG's wholesale cart proxy
   * and updates the drawer with the correct wholesale prices.
   */
  function applyWholesalePricing(cart) {
    if (typeof window.isWsgCustomer === 'undefined' || !window.isWsgCustomer) return;
    if (!cart || cart.item_count === 0) return;

    var cache = getWsgPriceCache();
    if (Object.keys(cache).length === 0) {
      console.log('[Custom Cart Drawer] No WSG prices cached yet');
      return;
    }

    var hasWsgPrices = false;
    var wholesaleTotal = 0;

    cart.items.forEach(function(item) {
      var vid = String(item.variant_id);
      var drawerItem = elements.container.querySelector('.ccd-item[data-variant-id="' + vid + '"]');
      if (!drawerItem) return;

      if (cache[vid]) {
        hasWsgPrices = true;
        var unitPrice = cache[vid];
        var linePrice = unitPrice * item.quantity;
        wholesaleTotal += linePrice;

        var priceEl = drawerItem.querySelector('.ccd-item__price');
        if (priceEl) {
          priceEl.innerHTML = formatMoney(linePrice);
        }
      } else {
        wholesaleTotal += item.final_line_price;
      }
    });

    if (hasWsgPrices) {
      var footerValue = elements.container.querySelector('.ccd-footer__value');
      if (footerValue) {
        footerValue.textContent = formatMoney(wholesaleTotal);
      }
      console.log('[Custom Cart Drawer] Applied wholesale prices from cache. Total: ' + formatMoney(wholesaleTotal));
    }
  }


  /**
   * Renderizar carrito vacio
   */
  function renderEmptyCart() {
    var html = '<div class="ccd-scrollable">';
    html += '<div class="ccd-empty">';
    html += '<p class="ccd-empty__text">Your cart is empty</p>';
    html += '<a href="/collections/all" class="ccd-empty__link">Continue shopping</a>';
    html += '</div>';
    html += '</div>';
 
    elements.container.innerHTML = html;
  }
 
  /**
   * Actualizar cantidad de un item
   */
  function updateItemQuantity(key, quantity) {
    if (state.isLoading) return;
 
    setLoading(true);
 
    fetch(config.routes.cartChange, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(cart) {
      state.cart = cart;
      renderCart(cart);
      updateCartBubble(cart);
      setLoading(false);
    })
    .catch(function(error) {
      console.error('[Custom Cart Drawer] Error al actualizar cantidad:', error);
      setLoading(false);
    });
  }
 
  /**
   * Eliminar item del carrito
   */
  function removeItem(key) {
    updateItemQuantity(key, 0);
  }
 
  /**
   * Abrir drawer
   */
  function openDrawer() {
    if (state.isOpen) return;
 
    state.isOpen = true;
    elements.drawer.classList.add(config.classes.drawerOpen);
 
    if (elements.overlay) {
      elements.overlay.classList.add(config.classes.overlayVisible);
    }
 
    document.body.classList.add(config.classes.bodyOpen);
    document.body.style.overflow = 'hidden';

    // Prevent native theme drawer from showing - remove its body classes
    // Run immediately and also after a short delay to catch theme.js race condition
    function suppressNativeDrawer() {
      document.body.classList.remove('js-drawer-open', 'js-drawer-open-right');
      var nativeDrawer = document.getElementById('CartDrawer');
      if (nativeDrawer) { nativeDrawer.classList.remove('drawer--is-open'); }
    }
    suppressNativeDrawer();
    setTimeout(suppressNativeDrawer, 50);
    setTimeout(suppressNativeDrawer, 150);

        console.log('[Custom Cart Drawer] Drawer abierto');
  }
 
  /**
   * Cerrar drawer
   */
  function closeDrawer() {
    if (!state.isOpen) return;
 
    state.isOpen = false;
    elements.drawer.classList.remove(config.classes.drawerOpen);
 
    if (elements.overlay) {
      elements.overlay.classList.remove(config.classes.overlayVisible);
    }
 
    document.body.classList.remove(config.classes.bodyOpen);
    document.body.style.overflow = '';

    // Also clean up native theme drawer classes
    document.body.classList.remove('js-drawer-open', 'js-drawer-open-right');

        console.log('[Custom Cart Drawer] Drawer cerrado');
  }
 
  /**
   * Establecer estado de carga
   */
  function setLoading(loading) {
    state.isLoading = loading;
 
    if (loading) {
      elements.drawer.classList.add(config.classes.loading);
    } else {
      elements.drawer.classList.remove(config.classes.loading);
    }
  }
 
  /**
   * Actualizar burbuja del carrito en el header
   */
  function updateCartBubble(cart) {
    var count = cart ? cart.item_count : 0;
 
    // Actualizar todos los elementos de contador del carrito
    document.querySelectorAll('.cart-link__bubble, .cart-count, .cart-link__count, [data-cart-count]').forEach(function(el) {
      if (count > 0) {
        el.textContent = count;
        el.classList.add('cart-link__bubble--visible');
        el.style.display = '';
      } else {
        el.textContent = '';
        el.classList.remove('cart-link__bubble--visible');
      }
    });
  }
 
  /**
   * Disparar eventos para compatibilidad con otros scripts
   */
  function dispatchCartEvents(item) {
    // Evento jQuery si esta disponible
    if (typeof jQuery !== 'undefined') {
      jQuery('body').trigger('added.ajaxProduct');
      jQuery('body').trigger('ajaxCart.afterCartLoad');
    }
 
    // Eventos nativos
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart: state.cart, item: item }
    }));
 
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: { product: item }
    }));
  }
 
  /**
   * Mostrar error
   */
  function showError(form, error) {
    var message = 'Error adding to cart';
 
    if (error && error.description) {
      message = error.description;
    } else if (error && error.message) {
      message = error.message;
    }
 
    // Remover errores previos
    var existingError = form.querySelector('.custom-cart-error');
    if (existingError) {
      existingError.remove();
    }
 
    // Agregar nuevo error
    var errorDiv = document.createElement('div');
    errorDiv.className = 'custom-cart-error errors text-center';
    errorDiv.style.cssText = 'color: #c00; padding: 10px; margin-bottom: 10px;';
    errorDiv.textContent = message;
    form.insertBefore(errorDiv, form.firstChild);
 
    // Remover error despues de 5 segundos
    setTimeout(function() {
      if (errorDiv.parentNode) {
        errorDiv.remove();
      }
    }, 5000);
  }
 
  /**
   * Formatear dinero
   */
  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
 
    var value = (cents / 100).toFixed(2);
    var format = config.moneyFormat;
 
    return format
      .replace('{{amount}}', value)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', value.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
  }
 
  /**
   * Obtener URL de imagen con tamano especifico
   */
  function getSizedImageUrl(url, size) {
    if (!url) return '';
 
    // Remover parametros de query existentes
    var baseUrl = url.split('?')[0];
 
    // Insertar el tamano antes de la extension
    var match = baseUrl.match(/\.(jpg|jpeg|gif|png|webp)(\?.*)?$/i);
    if (match) {
      return baseUrl.replace(match[0], '_' + size + match[0]);
    }
 
    return url;
  }
 
  /**
   * Escapar HTML
   */
  function escapeHtml(text) {
    if (!text) return '';
 
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }
 
  // Inicializar cuando el DOM este listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
  // Exponer API publica
  window.CustomCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: fetchCart,
    getCart: function() { return state.cart; }
  };
})();

// Función para ocultar/mostrar el chat de Shopify
function toggleShopifyChat(hide) {
  const shopifyChat = document.getElementById('shopify-chat');
  if (shopifyChat) {
    shopifyChat.style.display = hide ? 'none' : '';
    shopifyChat.style.visibility = hide ? 'hidden' : '';
  }
}

// Cuando abres el drawer:
function openCartDrawer() {
  document.getElementById('CustomCartDrawer').classList.add('is-open');
  document.getElementById('CustomCartOverlay').classList.add('is-visible');
  toggleShopifyChat(true); // Ocultar chat
}

// Cuando cierras el drawer:
function closeCartDrawer() {
  document.getElementById('CustomCartDrawer').classList.remove('is-open');
  document.getElementById('CustomCartOverlay').classList.remove('is-visible');
  toggleShopifyChat(false); // Mostrar chat
}